import React, {
  useContext,
  createContext
} from 'react'
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import firebaseConfig from '../firebaseConfig'
const FirebaseContext = createContext({
  app: {},
  analytics: {}
})
const FirebaseProvider = ({ children }) => {
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
  return (
    <FirebaseContext.Provider value={{
      app,
      analytics
    }}>
      {children}
    </FirebaseContext.Provider>
  )
}
const useFirebase = () => useContext(FirebaseContext)
export { useFirebase, FirebaseProvider }